import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors } from '../../../themes';
import { Button } from '../../crop-circle/Button';

export type QuickConfirmExecutionComponentProps = {
  options: string[];
  confirmedValue: string;
  onChange: (confirmedValue: string) => void;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const QuickConfirmExecutionComponentOld = (
  props: QuickConfirmExecutionComponentProps
) => {
  const lastValue = props.options[props.options.length - 1];

  return (
    <View style={styles.buttonsContainer}>
      {props.options.length > 1
        ? props.options.map((confirmedValue) => {
            const buttonBackgroundStyle = [styles.button];
            const buttonLabelStyle = [styles.buttonLabel];

            if (confirmedValue === props.confirmedValue) {
              buttonBackgroundStyle.push(styles.currentStateButton);
              buttonLabelStyle.push(styles.currentButtonLabel);
            }

            return (
              <TouchableOpacity
                key={confirmedValue}
                activeOpacity={0.7}
                style={[
                  buttonBackgroundStyle,
                  lastValue === confirmedValue && styles.bottomValueButton,
                ]}
                onPress={() => props.onChange(confirmedValue)}
              >
                <Text style={buttonLabelStyle}>{confirmedValue}</Text>
              </TouchableOpacity>
            );
          })
        : null}
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove to QuickConfirmExecutionComponentBase after feature is fully rolled out
const QuickConfirmExecutionComponentBase = (
  props: QuickConfirmExecutionComponentProps
) => {
  const lastValue = props.options[props.options.length - 1];

  return (
    <View style={stylesCropCircle.buttonsContainer}>
      {props.options.length > 1
        ? props.options.map((confirmedValue) => {
            return (
              <Button
                key={confirmedValue}
                onPress={() => props.onChange(confirmedValue)}
                size="large"
                variant="rectangular"
                state={lastValue === confirmedValue ? 'active' : 'default'}
              >
                {confirmedValue}
              </Button>
            );
          })
        : null}
    </View>
  );
};

export const QuickConfirmExecutionComponent = (
  props: QuickConfirmExecutionComponentProps
) => {
  if (props.useCropCircle) {
    return <QuickConfirmExecutionComponentBase {...props} />;
  }

  return <QuickConfirmExecutionComponentOld {...props} />;
};

const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  button: {
    height: 52,
    borderWidth: 2,
    borderRadius: 51,
    borderColor: Colors.blue,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  currentStateButton: {
    backgroundColor: Colors.blue,
  },
  bottomValueButton: {
    marginBottom: 0,
  },
  buttonLabel: {
    color: Colors.black,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19,
  },
  currentButtonLabel: {
    color: Colors.white,
  },
});

const stylesCropCircle = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 16,
  },
});
